import React, { ReactNode } from 'react';
import { withRouter } from 'react-router';
import { BlackListErrorComponentView } from './BlackListErrorComponentView';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { FooterComponent } from '../common/footer/FooterComponent';
import { HeaderComponent } from '../common/header/HeaderComponent';

// WRQ-2990_旅行保険　直扱販売のための対応 START
/**
 * ブラックリストエラー表示コンポーネント
 */
class BlackListErrorComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new BlackListErrorComponentView(), props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<main className="page-error">
					<div className="message">
						<h1>当社の引受基準により保険のお引き受けができません。<br/>ご了承のほど、お願いいたします。</h1>
					</div>
					<div className="b-error-margin"/>
				</main>
				<FooterComponent />
			</>
		);
	}
	// --------------------------------------------------------------------------
}

export default withRouter(BlackListErrorComponent);
// WRQ-2990_旅行保険　直扱販売のための対応 END